import React from 'react'
import { useTomPicturesFilters } from '../../root/hooks/use-tom-pictures-filters'
import { PicturesList } from '../../tom/components/pictures-list'
import { useDevicePictures } from '../../tom/hooks/useDevicePictures'

export function DevicePictures({ deviceId }) {
    const { filters, setFilters } = useTomPicturesFilters()
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetching,
        isFetchingNextPage
    } = useDevicePictures(deviceId, filters)

    return (
        <PicturesList
            queryKey={`devicePictures-${deviceId}`}
            data={data}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isLoading={isLoading}
            isFetching={isFetching}
            isFetchingNextPage={isFetchingNextPage}
            filters={filters}
            setFilters={setFilters}
        />
    )
}
